export default "__VITE_ASSET__jBD8kH7R__"